import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { Avatar, Button, Flex, Popconfirm, Table, Tabs, Typography, Form, Input, DatePicker, Select, Modal } from "antd";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import AvatarPicker from '../components/AvatarPicker';
import { get, patch, post, remove, slugify, xdelete } from '../services/api';
import { useDispatch, useSelector } from "react-redux";
import { setProjects } from "../features/projects";
import moment from 'moment';
import { Link } from "react-router-dom";

const { TextArea } = Input;
const { Option } = Select;

// Example user data

export default function Project ({project}) {
  const [lists, setLists] = useState([]);
  const [activeTab, setActiveTab] = useState('overview');
  const [form] = Form.useForm();
  const user = useSelector((state) => state.user);
  const users = useSelector((state) => state.users.filter(u => u.id !== user.id));
  const projects = useSelector((state) => state.projects);
  const dispatch = useDispatch();
  
  const handleUpdate = async (values) => {
    try {
      const updatedProject = await patch(`/users/${user.id}/projects`, values, { id: project.id });
      if (updatedProject.count) {
        const updatedProjects = await get(`/users/${user.id}/projects`);
        dispatch(setProjects(updatedProjects));
        setActiveTab('overview'); // Switch back to overview tab after successful update
      }
    } catch (error) {
      console.error('Failed to update project:', error);
    }
  };
  
  const selectType = (key) => {
    setActiveTab(key);
    
    if (key === 'edit') {
      form.setFieldsValue({
        name: project.name,
        description: project.description,
        icon: project.icon || '',
        startDate: project.startDate ? moment(project.startDate) : null,
        endDate: project.endDate ? moment(project.endDate) : null,
        priority: project.priority || 'medium'
      });
    }
  }
  const addList = async () => {
    const list = await post(`/users/${user.id}/lists`, {
      "name": "List "+(lists.length+1),
      "projectId": project.id
    });
    const _lists = [
      ...lists,
      list
    ];
    setLists(_lists);
    dispatch(setProjects(projects.map(p => p.id === project.id ? {...p, lists: _lists } : p)));
  }
  const updateListName = async (name, list) => {
    const res = await patch(`/users/${user.id}/lists`, { name }, { id: list.id });
    if(res.count) {
      const _lists = lists.map(l => l.id === list.id ? {...l, name } : l);
      setLists(_lists);
      dispatch(setProjects(projects.map(p => p.id === project.id ? {...p, lists: _lists } : p)));
    }
  }
  const deleteList = async (list) => {
    const res = await xdelete(`/users/${user.id}/lists`, { id: list.id });
    if(res.count) {
      const _lists = lists.filter(l => l.id !== list.id);
      setLists(_lists);
      dispatch(setProjects(projects.map(p => p.id === project.id ? {...p, lists: _lists } : p)));
    }
  }
  const onAddUser = async (user, list, access) => {
    const access_granted = await post(`/lists/${list.id}/list-accesses`, {
      userId: user,
      access
    });
    if(access_granted) {
      setLists(lists.map((l) => {
        return l.id === list.id ? {
          ...l,
          listAccesses: [ ...(l.listAccesses || []), access_granted ]
        } : l
      }));
      console.log('access_granted', access_granted);
    }
  }
  const onRemoveUser = async (user, list) => {
    const access_removed = await xdelete(`/lists/${list.id}/list-accesses`, {
      userId: user
    });
    if(access_removed) {
      setLists(lists.map((l) => {
        return l.id === list.id ? {
          ...l,
          listAccesses: l.listAccesses.filter(la => la.userId !== user)
        } : l
      }));
      console.log('access_removed', access_removed);
      console.log('remove', user, list);
    }
  }
  useEffect(() => {
    setLists(project.lists.filter(l => l));
  }, [project.lists]);
  useEffect(() => {
    get(`/projects/${project.id}/lists`, {
      include: [{
        relation: "listAccesses",
        scope: {
          where: {
            userId: {
              neq: user.id
            }
          }
        }
      }]
    }).then((lists) => {
      setLists(lists);
    });
  }, [project.id, user.id]);

  return <Flex gap={20}>
    <div style={{ marginLeft: '16px', marginTop: '12px' }}>
      <Tabs
        activeKey={activeTab}
        tabPosition={'left'}
        size="small"
        style={{ width: "200px" }}
        onChange={selectType}
        items={[
          {
            label: `Lists Overview`,
            key: 'overview'
          },
          {
            label: `Edit Project`,
            key: 'edit'
          }
        ]}
      />
    </div>
    <div style={{ flex: 1 }}>
      
      {activeTab === 'edit' ? (
        <div style={{ marginRight: '16px' }}>
          <Form
            form={form}
            name="edit_project"
            layout="vertical"
            onFinish={handleUpdate}
            initialValues={{
              name: project.name,
              description: project.description,
              icon: project.icon || '',
              priority: project.priority || 'medium',
            }}
          >
            <Form.Item
              label="Project Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please input the project name!',
                },
              ]}
            >
              <Input />
            </Form.Item>
            
            <Form.Item
              label="Icon URL"
              name="icon"
              rules={[
                {
                  required: false,
                  message: 'Please input the project icon URL!',
                },
                {
                  type: 'url',
                  message: 'Please enter a valid URL',
                }
              ]}
            >
              <Input placeholder="Enter image URL for project icon" />
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: false,
                  message: 'Please input the project description!',
                },
              ]}
            >
              <TextArea rows={4} />
            </Form.Item>

            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[
                {
                  required: false,
                  message: 'Please select the project start date!',
                },
              ]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              label="End Date"
              name="endDate"
              rules={[
                {
                  required: false,
                  message: 'Please select the project end date!',
                },
              ]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              label="Priority"
              name="priority"
              rules={[
                {
                  required: false,
                  message: 'Please select the project priority!',
                },
              ]}
            >
              <Select>
                <Option value="high">High</Option>
                <Option value="medium">Medium</Option>
                <Option value="low">Low</Option>
              </Select>
            </Form.Item>

            <Form.Item style={{ textAlign: 'right' }}>
              <Button type="primary" htmlType="submit">
                Update Project
              </Button>
            </Form.Item>
          </Form>
        </div>
      ) : (
        <Table
          dataSource={lists}
          rowKey={(list) => (slugify(list ? list.name : ''))}
          showHeader={true}
          pagination={false}
          size={"small"}
          // title={() => <Typography.Title level={3} style={{ marginTop: "-10px" }}>Lists</Typography.Title>}
          footer={() => (
            <>
              <div style={{ textAlign: "right" }}>
                <Button type="primary" onClick={addList}>Add</Button>
              </div>
            </>
          )}
        >
          <Column
            title="List"
            dataIndex="name"
            key="name"
            width={"50%"}
            render={(name, list, i) => {
              return <Typography.Text editable={{ onChange: (name) => updateListName(name, list) }} style={{ height: "100%", top: "7px", left: "0", color: name ? "inherit" : "#888" }}><Link to={`/${slugify(project?.name || '')}/${slugify(name || '')}`}>{name || 'List '+i}</Link></Typography.Text>;
            }}
          />
          <Column
            title="All Mode"
            dataIndex="appointed"
            key="access_all"
            width={"25%"}
            render={(t, list) => {
              const readOnly = project.lists.findIndex(l => l && l.id === list.id) < 0;
              return <AvatarPicker readOnly={readOnly} defaultSelectedUsers={ list.listAccesses ? list.listAccesses.filter(la => la.access).map(la => la.userId) : [] } users={
                users.filter(u => list.listAccesses ? !list.listAccesses.find(la => la.userId === u.id && la.access === false) : true )
              } onRemoveUser={ (u)=>{ onRemoveUser(u, list) }} onAddUser={ (u)=>{ onAddUser(u, list, true) }}/>
            }}
          />
          <Column
            title="Me Mode"
            dataIndex="appointed"
            key="access_me"
            width={"25%"}
            render={(t, list) => {
              const readOnly = project.lists.findIndex(l => l && l.id == list.id) < 0;
              return <AvatarPicker readOnly={readOnly} defaultSelectedUsers={ list.listAccesses ? list.listAccesses.filter(la => !la.access).map(la => la.userId) : [] } users={
                users.filter(u => list.listAccesses ? !list.listAccesses.find(la => la.userId === u.id && la.access === true) : true )
              } onRemoveUser={ (u)=>{ onRemoveUser(u, list) }} onAddUser={ (u)=>{ onAddUser(u, list, false) }}/>
            }}
          />
          <Column
            render={(tmp, list) => {
              return <Popconfirm
                title="Delete List"
                placement="bottomRight"
                description="Are you sure to delete this list?"
                onConfirm={ () => deleteList(list) }
                onCancel={console.log}
                okText="Yes"
                cancelText="No"
              >
                <Button shape="circle" icon={<DeleteOutlined />} />
              </Popconfirm>
            }}
          />
        </Table>
      )}
    </div>
  </Flex>
}